<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: 'category',

          // SINGLE
          single: false,

          // CHECKBOX
          checkbox: true,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Nama Kategori',
              width: '200px',
              value: 'cat_title',
              freeze: false,
              hide: false
            },
            {
              text: 'Deskripsi',
              width: '400px',
              value: 'cat_content',
              freeze: false,
              hide: false,
              format: 'regex'
            },
            {
              text: 'Tipe',
              width: '100px',
              value: 'cat_type',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: 'cat_',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'title',
              label: 'Nama Kategori',
              type: 'text',
              placeholder: 'Contoh. Klaten Bersinar',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'content',
              label: 'Deskripsi',
              type: 'texteditor',
              placeholder: 'Contoh. Tuliskan deskripsi disini',
              value: '',
              rows: 5,
              required: false
            },
            {
              field: 'image',
              label: 'Gambar',
              type: 'image',
              placeholder: 'Contoh. https://via.placeholder.com/640x480.png/0000bb?text=images+ex',
              value: '',
              width: '100%',
              required: false
            },
            {
              field: 'type',
              label: 'Tipe',
              type: 'select',
              placeholder: 'Contoh. Report',
              value: 'news',
              option: [
                {
                  text: 'Report',
                  value: 'report'
                },
                {
                  text: 'Blog',
                  value: 'blog'
                },
                {
                  text: 'News',
                  value: 'news'
                },
                {
                  text: 'Agenda',
                  value: 'agenda'
                },
                {
                  text: 'Donasi',
                  value: 'donasi'
                }
              ],
              width: '40%',
              required: false
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              text: 'Kategori',
              button: true,
              api: 'category/create',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'category/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'category/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: false,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>